<!--
  FGA Manager Component Template
  
  Displays groups and users from FGA with loading and error states.
-->

<section class="fga-manager" role="region" aria-label="FGA Authorization Manager">

  <!-- Configuration Status -->
  <div class="fga-manager__config">
    @if (errorStateService.isUnauthorized() && handleUnauthorizedInternally) {
      <!-- Unauthorized State (403/401) - shown only when handleUnauthorizedInternally is true -->
      <fga-unauthorized
        (requestAccess)="onRequestAccess()"
        (retry)="onRetry()">
      </fga-unauthorized>
    } @else if (!isInitialized && !initError) {
      <!-- Loading State -->
      <div
        class="fga-manager__loading"
        role="status"
        aria-live="polite"
        aria-label="Initializing component">
        <ngkit-progress-spinner [size]="32"></ngkit-progress-spinner>
        <span>Initializing...</span>
      </div>
    } @else if (initError) {
      <!-- Error State -->
      <ngkit-inline-message
        severity="error"
        title="Initialization Error"
        [message]="initError">
      </ngkit-inline-message>
    } @else {
      <section class="fga-manager__split">
        <fga-nav-bar
          [activeView]="activeView"
          [isAuthzAdmin]="isAuthzAdmin()"
          (viewChange)="onViewChange($event)">
        </fga-nav-bar>
        @if (activeView === 'groups') {
          <aside class="fga-manager__sidebar">
            <fga-groups-list
              [state]="groupState"
              [selectedId]="groupState.selectedGroupId()"
              [canCreateGroup]="isAuthzAdmin()"
              [addingGroup]="groupState.addingGroup"
              [addGroupError]="groupState.addGroupError"
              [groupNames]="groupState.groupNames"
              (selected)="handleGroupSelect($event)"
              (addGroup)="onAddGroup($event)"
              (addGroupInputChange)="onAddGroupInputChange()">
            </fga-groups-list>
          </aside>
          <main class="fga-manager__content min-width-0" aria-label="Group details">
            @if (groupState.selectedGroupId()) {
              <fga-group-view
                [group]="groupState.selectedGroup()"
                (membershipEnrichmentLoading)="onMembershipEnrichmentLoading($event)">
              </fga-group-view>
            }
          </main>
        } @else if (activeView === 'users') {
          <main
            class="fga-manager__content fga-manager__content--users min-width-0"
            aria-label="User administration">
            <fga-org-users-view
              [organisationId]="organisationId"
              [organisationName]="organisationName">
            </fga-org-users-view>
          </main>
        } @else if (activeView === 'services') {
          <aside class="fga-manager__sidebar">
            <fga-services-list
              [selectedId]="selectedServiceId()"
              (selected)="onServiceSelect($event)">
            </fga-services-list>
          </aside>
          <main class="fga-manager__content min-width-0" aria-label="Service details">
            <div class="fga-manager__service-content">
              @if (selectedServiceName(); as serviceName) {
                <h3 class="fga-manager__service-title">{{ serviceName }}</h3>
              } @else {
                <p class="fga-manager__service-prompt">Select a service to view its details.</p>
              }
            </div>
          </main>
        }
      </section>
    }
  </div>
</section>
